<template>
    <div>
        <div class="bg">
            <div class="shade_star"></div>

            <div class="content">
                <div class="head">
                    <p>{{ $t('message.shareEarn.head') }}</p>
                    <div class="_info_box">
                        <h1>{{ $t('message.shareEarn.reward') }}</h1>
                        <button @click="signUP" v-if="!isLogin">
                            {{ $t('message.shareEarn.signUp') }}
                        </button>
                    </div>
                </div>

                <div class="userinfo">
                    <dl>
                        <dd class="photo"  :style="{backgroundImage: `url(${ (inviteUserInfo && inviteUserInfo.headImg && inviteUserInfo.headImg.url )|| 'https://fr-static.shopshops.top/20220610/photo.40042c4b908535b2.png' })`}"></dd>
                        <dt>
                            {{ $t('message.shareEarn.expiresInfo', {username: inviteUserInfo && inviteUserInfo.userName}) }}
                        </dt>
                    </dl>
                    
                    <p class="_desc">
                        {{ $t('message.shareEarn.msg') }}
                    </p>

                    <div class="brand"></div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import {plateForm} from '@/utils/'
import api from "@/api/api_list";

export default {
    data(){
        return {
            isIOS: plateForm().isIOS,
            isLogin: false,
            inviteUserInfo: null,
            isEN: this.$i18n.locale === 'en'
        }
    },

    created(){

        try{
            this.sa.track({
                eventId: 'openReferralUserH5',
                eventParam: {
                    platformType: 'H5',
                }
            });
        }catch(e){
            console.log(e)
        }

        // @todo 必须要有inviteCode  userNum否则不允许绑定，直接跳到首页
        if( !this.$route.query.userNum ){
            this.$router.replace({name: 'home', query: this.$route.query, params: { type: 'Live' }});
            return;
        }

        this.isLogin = this.$isLogin(null, false);

        if( this.isLogin ){
            this.openDownloadGuid();
        }else{
            // 默认不打开登录注册面板 ，需要等用户点击按钮
            // this.$login.open(()=>{
            //     this.openDownloadGuid();
            // });
        }

        let userNum = this.$route.query.userNum;
        if (!userNum) {
            return;
        }

        this.getInviteUserInfo( userNum );
    },

    methods:{
        signUP(){
            
             try{
                this.sa.track({
                    eventId: 'clickReferralUserLogin',
                    eventParam: {
                        platformType: 'H5',
                    }
                });
            }catch(e){
                console.log(e)
            }

            this.$login.open(()=>{
                this.openDownloadGuid();
            });
        },

        async getInviteUserInfo( userNum ) {
            try {
                let {code , msg, result} = await api.get_user_info_by_user_num({
                    userNum: userNum
                });
                if (
                    code ===0 &&
                    result &&
                    result.intgUser &&
                    result.intgUser.userNum
                ) {
                    this.inviteUserInfo = result.intgUser;
                }
            } catch (e) {
                console.log(e);
            }
        },
        
        openDownloadGuid(){
            // 是否需要展示引导下载弹窗 - 这个标识用于判断是否展示 绑定邀请码弹窗。
            // try{
            //   // 从邀请过来的页面，第一次登录后需要弹出引导
            //   const inviteInfoStr = sessionStorage.getItem("inviteInfo");
            //   if (inviteInfoStr !== null) {
            //     const inviteInfo = JSON.parse(inviteInfoStr); 

            //     if ( inviteInfo !== null && inviteInfo.activityType === "inviteCode" ) {
            //         // 唤起引导下载页
            //         this.$shareGuide.open( true, ()=>{
            //             // 如果用户未绑定邀请码 则展示绑定邀请码弹窗
            //             if( !intgUser.inviteUserNum ){
            //               this.$bindInviteCode.open({
            //                 bindComplete: (bindResult) => { 
            //                     if (this.loginSuccess) {
            //                       this.loginSuccess();
            //                     }
            //                     if (bindResult) {
            //                       this.$downloadGuide.open();
            //                     }
            //                 }
            //               });
            //             }
            //         } );
            //     }
            //   }
            
            // }catch(e){
            //   console.log(e);
            // }
            // 如果已登录，直接弹出引导下载
            let _instance = this.$shareGuide.open(()=>{
                // 关闭弹窗后 触发 onCose 事件 - 并跳转首页
                this.$router.replace({name: 'home', query: this.$route.query, params: { type: 'Live' }});
            });

            // andriod用户 打开3s 自动关闭弹窗，并跳转首页
            if( !this.isIOS ){
                setTimeout(()=>{
                    _instance.closePopup();
                }, 3000);
            }
            
            
        }
    }
}
</script>

<style lang="less" scoped>



.bg{
    margin: 0 auto;
    width: 375px;
    min-height: 100vh;
    font-size: 12px;
    color: #FFF;;
    background: url('../../assets/imgs/share_earn/bg.png') no-repeat 0 0 ;
    background-size: cover;
    position: relative;
}
.shade_star{
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    width: 375px;
    height: 772/2px;
    background: url('../../assets/imgs/share_earn/caidai.png') no-repeat 0 0 ;
    background-size: cover;
    pointer-events: none;
}
.content{
    width: 726/2px;
    height: 1578/2px;
    background: url('../../assets/imgs/share_earn/bg-card.png') no-repeat 0 0 ;
    background-size: cover;
    box-sizing: border-box;
    padding-top: 140px;
    .head{
        box-sizing: border-box;
        color: #000;
        font-size: 13px;
        text-align: center;
        padding-top: 30px;
        height: 150px;
        ._info_box{
            height: 125px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }
        h1{
            font-size: 24px;
            padding-top: 0;
            padding-bottom: 10px;
        }
        button{
            background: #050505;
            font-size: 20px;
            color: #fff;
            width: 214px;
            height: 50px;
            border-radius: 40px;
        }
    }
    .userinfo{
        color: #000;
        padding: 0 50px;
        padding-top: 45px;
        dd{
            border-radius: 100%;
            margin: 10px auto;
            width: 80px;
            height: 80px;
            background-size: cover;
            background-repeat: no-repeat;
            // background-color: #eee;
            background-position:center center;
        }
        dt{
            font-size: 13px;
            padding-top: 5px;
            padding-bottom: 10px;
            i{
                font-weight: bold;
                font-style: normal;
            }
        }
        ._desc{
            font-size: 13px;
            opacity: .6;
            line-height: 1.5;
        }
        .brand{
            width: 506/2px;
            height: 352/2px;
            background: url('../../assets/imgs/share_earn/brand.png') no-repeat 0 0 ;
            background-size: cover;
            margin: 0 auto;
            margin-top: 20px;
        }
    }
}
</style>